
import React from "react";
import { Button } from "@/components/ui/button";
import { RefreshCcw, Plus } from "lucide-react";

export interface UsageTrackerHeaderProps {
  onRefresh: () => void;
  onAddGroup: () => void;
}

const UsageTrackerHeader: React.FC<UsageTrackerHeaderProps> = ({ 
  onRefresh, 
  onAddGroup 
}) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
      <h2 className="text-xl font-bold mb-2 sm:mb-0">Quick Usage Tracker</h2>
      
      <div className="flex space-x-2">
        <Button 
          variant="outline" 
          size="sm"
          onClick={onRefresh}
          className="flex items-center"
        >
          <RefreshCcw className="mr-1 h-4 w-4" />
          Refresh
        </Button>
        
        <Button 
          size="sm"
          onClick={onAddGroup}
          className="flex items-center"
        >
          <Plus className="mr-1 h-4 w-4" />
          Add Group
        </Button>
      </div>
    </div>
  );
};

export default UsageTrackerHeader;
